import type { ConstructionAd } from "@mobility-item-page/types";
import { KeyInfo } from "../../key-info/KeyInfo.tsx";
import { AnnualTax } from "../AnnualTax.tsx";
import { HoursUsed } from "../agriculture/HoursUsed.tsx";
import { BootSize } from "../BootSize.tsx";
import { ChassisNumber } from "../ChassisNumber.tsx";
import { Engine } from "../Engine.tsx";
import { ModelYear } from "../ModelYear.tsx";
import { SpecificationsArea } from "../SpecificationsArea.tsx";
import { Transmission } from "../Transmission.tsx";
import { VehicleGroup } from "../VehicleGroup.tsx";
import { Weight } from "../Weight.tsx";
import { AdditionalHydraulics } from "./AdditionalHydraulics.tsx";
import { AuxiliaryHydraulicsPerformance } from "./AuxiliaryHydraulicsPerformance.tsx";
import { Cab } from "./Cab.tsx";
import { CeMarked } from "./CeMarked.tsx";
import { ChassisVariant } from "./ChassisVariant.tsx";
import { LiftCapacity } from "./LiftCapacity.tsx";
import { LiftHeight } from "./LiftHeight.tsx";
import { MaxSpeed } from "./MaxSpeed.tsx";
import { ServiceContract } from "./ServiceContract.tsx";
import { StatementOfCompliance } from "./StatementOfCompliance.tsx";
import { Workload } from "./Workload.tsx";

export const ConstructionSpecifications = ({ ad }: { ad: ConstructionAd }) => {
  return (
    <SpecificationsArea>
      <KeyInfo>
        {/*General information*/}
        <AnnualTax annualTaxUrl={ad.annual_tax_url} />
        <VehicleGroup segment={ad.segment} />
        <ModelYear year={ad.year} />
        <ChassisNumber chassisNumber={ad.chassis_number} />

        {/*Product properties*/}
        <Engine engine={ad.engine} />
        <Cab cab={ad.cab} />
        <ChassisVariant chassisVariant={ad.chassis_variant} />
        <Transmission transmission={ad.transmission} />
        <BootSize bootSize={ad.boot_size} />
        <Weight weight={ad.weight} />
        <LiftHeight liftHeight={ad.lift_height} />
        <LiftCapacity liftCapacity={ad.lift_capacity} />
        <HoursUsed hoursUsed={ad.hours_used} />
        <Workload workload={ad.workload} />
        <MaxSpeed maxSpeed={ad.max_speed} />
        <AuxiliaryHydraulicsPerformance auxiliaryHydraulicsPerformance={ad.auxiliary_hydraulics_performance} />
        <AdditionalHydraulics additionalHydraulics={ad.additional_hydraulics} />

        {/*Other*/}
        <CeMarked ceMarked={ad.ce_marked} />
        <StatementOfCompliance statementOfCompliance={ad.statement_of_compliance} />
        <ServiceContract serviceContract={ad.service_contract} />
      </KeyInfo>
    </SpecificationsArea>
  );
};
